// import Hero from "./Hero/Index";
import Cards from "./Card/Index";
// import Details from "./Details/index";

export default function Index(){
    return(
        <div>
            {/* < Hero /> */}
            < Cards />
            {/* <Details /> */}
        </div>
    )
}